// src/components/MintingPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useAppContext } from "../context/AppContext";

const MintingPage = () => {
  const navigate = useNavigate();
//   const { setAppState } = useAppContext();

  const [blockchain, setBlockchain] = useState("Ethereum");
  const [title, setTitle] = useState("");
  const [royalties, setRoyalties] = useState("");

  const handleNext = () => {
    if (!title || !royalties) {
      alert("Please complete all fields.");
      return;
    }
    // setAppState((prev) => ({
    //   ...prev,
    //   mintingDetails: { blockchain, title, royalties },
    // }));
    console.log("{ blockchain, title, royalties }", { blockchain, title, royalties });
    navigate("/fractionalization");
    
  };

  return (
    <div className="minting-page">
      <h2>Mint Your NFT</h2>
      <select onChange={(e) => setBlockchain(e.target.value)} value={blockchain}>
        <option value="Ethereum">Ethereum</option>
        <option value="Polygon">Polygon</option>
        <option value="Solana">Solana</option>
      </select>
      <input
        type="text"
        placeholder="NFT Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <input
        type="number"
        placeholder="Royalties (%)"
        value={royalties}
        onChange={(e) => setRoyalties(e.target.value)}
      />
      <button onClick={handleNext}>Next Step</button>
    </div>
  );
};

export default MintingPage;
